import styles from "../styles/adminTabListItem.module.css";

export const AdminPageTabListItem = ({
  tab,
  onSelect,
  activeTab,
}: {
  tab: any;
  onSelect: (tab: any) => void;
  activeTab: any;
}) => {
  return (
    <div onClick={() => onSelect(tab)} className={`${styles.wrapper} ${activeTab === tab ? styles.activeTab : ""}`}>
      <div className={styles.tab}>
        <p className={`${styles.title} ${activeTab === tab ? styles.activeTab : ""}`}>{tab.title}</p>
      </div>
    </div>
  );
};
